import React from "react";
import { shade } from "polished";
import { RichText } from "prismic-dom";
import styled from "styled-components";
import { Box, Image as RebassImage } from "rebass";
import Text from "./Text";

const Wrapper = styled(Box)`
  padding: 0;
  &:first-child {
    margin-top: 0;
  }
`;

Wrapper.defaultProps = {
  is: "figure",
  mx: [-24, -32, 0],
  mt: [5, 7],
  mb: [5, 7],
};

const Image = styled(RebassImage)`
  width: 100%;

  &::selection {
    color: ${(props) => props.theme.colors.grey[2]};
    background-color: ${(props) => props.theme.colors.violet};
  }
`;

Image.defaultProps = {};

const CaptionContainer = styled(Box)`
  width: 100%;
  text-align: center;
`;

CaptionContainer.defaultProps = {
  is: "figcaption",
  px: [4, 5, 6, 8],
};

const Caption = styled(Text)`
  display: inline-block;
  max-width: 60rem;
  margin-top: 16px;
  text-align: initial;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  p {
    margin: 0;
    margin-bottom: ${(props) => props.theme.space[5]}px;
    font-weight: 400;
    line-height: 1.5;
    color: ${(props) => props.theme.colors.text};
    font-kerning: normal;
    font-variant-ligatures: common-ligatures;

    &:last-child {
      margin-bottom: 0;
    }
    &::selection {
      color: ${(props) => props.theme.colors.grey[2]};
      background-color: ${(props) => props.theme.colors.violet};
    }
  }
  p strong,
  p b {
    font-weight: ${(props) => props.theme.fontWeights.bold};
  }
  p a {
    color: ${(props) => props.theme.colors.violet};
    text-decoration: none;
    box-shadow: inset 0 -1px 0 ${(props) => props.theme.colors.violet};
    transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1),
      box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);
    will-change: color, box-shadow;

    &:hover {
      color: #fff;
      box-shadow: inset 0 -1.5em 0 ${(props) => props.theme.colors.violet};
    }
    &:active {
      color: #fff;
      box-shadow: inset 0 -1.5em 0 ${(props) => props.theme.colors.violet && shade(0.75, props.theme.colors.violet)};
    }
  }
`;

Caption.defaultProps = {
  is: "p",
};

let linkResolver = function (doc) {
  return "/" + doc.type;
};

const ImageSlice = (props) => (
  <Wrapper>
    <Image
      srcSet={
        props.imageSet[2] +
        " 1000w, " +
        props.imageSet[1] +
        " 2000w, " +
        props.imageSet[0] +
        " 2500w"
      }
      alt={props.alt}
    />
    <CaptionContainer>
      <Caption>
        {props.caption && (
          <span
            dangerouslySetInnerHTML={{
              __html: RichText.asHtml(props.caption, linkResolver),
            }}
          />
        )}
      </Caption>
    </CaptionContainer>
  </Wrapper>
);

ImageSlice.defaultProps = {
  image:
    "https://bankinformationcenter.cdn.prismic.io/bankinformationcenter/96772987cca22889439e3130b7c2525326fecbf9_child-labor11.jpg",
};

export default ImageSlice;



// WEBPACK FOOTER //
// ./src/components/ImageSlice.js